var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 10.6667L4.66669 7.33335L5.60002 6.36669L7.33335 8.10002V2.66669H8.66669V8.10002L10.4 6.36669L11.3334 7.33335L8.00002 10.6667ZM4.00002 13.3334C3.63335 13.3334 3.31935 13.2027 3.05802 12.9414C2.79669 12.68 2.66624 12.3662 2.66669 12V10H4.00002V12H12V10H13.3334V12C13.3334 12.3667 13.2027 12.6807 12.9414 12.942C12.68 13.2034 12.3662 13.3338 12 13.3334H4.00002Z",
    fill: "#FF9777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3640a2542ab408b6d2dc04b3b3a5691b.svg";
export { ForwardRef as ReactComponent };